<!-- eslint-disable max-len -->
<template>
  <div
    class="timeslot-item"
    :class="{'--selected': isSelected}"
  >
    <div class="timeslot-item__header">
      <div class="timeslot-item__info">
        <h2 class="timeslot-item__label">
          {{ tc('spaSoft.step1.itinerarySelection.timeSlotNumberLabel', {slotNumber: index + 1}) }}
        </h2>
        <h3 class="timeslot-item__time">
          {{ getTimeslotTimeRange(data.guestAvailabilities) }}
        </h3>
      </div>
      <div class="timeslot-item__select">
        <div class="input radio">
          <input
            :id="`timeslot-${index + 1}`"
            name="timeslot"
            :checked="isSelected"
            type="radio"
            :value="data.index"
            @input="handleSelectItinerary(data)"
          >
          <label
            class="sr-only"
            :for="`timeslot-${index + 1}`"
          >
            {{ tc('spaSoft.step1.itinerarySelection.timeSlotNumberLabel', {slotNumber: index + 1}) }}, {{ getTimeslotTimeRange(data.guestAvailabilities) }}
          </label>
        </div>
      </div>
    </div>
    <component
      :is="isMobile ? 'TimeslotTableMobile' : 'TimeslotTableDesktop'"
      v-for="(guestData, guestIndex) in data.guestAvailabilities"
      :key="`guest-${guestIndex}`"
      :guest-data="guestData"
      :index="guestIndex"
    />
  </div>
</template>

<script>
  import { mapActions, mapState, mapGetters } from 'vuex'
  import Tracking from '@mixins/tracking'
  import TimeslotTableDesktop from './timeslot-table-desktop.vue'
  import TimeslotTableMobile from './timeslot-table-mobile.vue'
  import TimeslotTableMixin from './timeslot-table'

  export default {
    name: 'TimeslotItem',
    components: {
      TimeslotTableDesktop,
      TimeslotTableMobile
    },
    mixins: [TimeslotTableMixin, Tracking],
    props: {
      data: {
        type: Object,
        required: true
      },
      index: {
        type: Number,
        required: true
      },
    },
    computed: {
      ...mapState('responsive', { wWidth: 'width' }),
      ...mapState('spaSoft', ['selectedItinerary', 'propertyData', 'hotelCode']),
      ...mapGetters('i18n', ['tc']),
      ...mapGetters('spaSoft', ['getTimeslotTimeRange']),
      ...mapGetters('currency', ['getDisplayPrice', 'orSelected']),
      isMobile() {
        return this.wWidth <= 767
      },
      isSelected() {
        return this.index === this.selectedItinerary?.index
      }
    },
    methods: {
      ...mapActions('spaSoft', ['selectItinerary', 'updateSelectedItineraryTrackingData']),
      handleSelectItinerary(data) {
        this.selectItinerary(data)
        this.updateSelectedItineraryTrackingData(
          this.getTrackingData('spaSoft', null, {
            event: 'appointmentSelection',
            hotelCode: this.hotelCode,
            stepNumber: 2.1,
            timeSlot: `${this.getTimeslotTimeRange(data.guestAvailabilities)}`,
            products: data.guestAvailabilities.flatMap((guestData, index) => guestData.itinerary.map((treatment) => ({
              guestNumber: index + 1,
              productType: 'Treatment',
              treatmentName: this.getTreatmentName({ guestNumber: index, itinerary: treatment }),
              treatmentType: this.timeSlotDetails({ guestNumber: index, itinerary: treatment })?.treatmentCategory?.title,
              duration: this.getTreatmentDuration({ guestNumber: index, itinerary: treatment }),
              price: this.getDisplayPrice({
                price: this.timeSlotDetails({ guestNumber: index, itinerary: treatment })?.selectedTimeSlot?.apiTreatmentDetails?.price.totalCalculated,
                fromCurrency: this.propertyData?.currency?.isoCode,
                toCurrency: this.orSelected(this.propertyData?.currency?.isoCode),
                noSymbol: true
              }),
              currency: this.orSelected(this.propertyData?.currency?.isoCode),
              appointmentTime: this.getStartEndLabel(treatment),
              preferredTherapistGender: this.getGenderPreference({ guestNumber: index, itinerary: treatment })
            })))
          })
        )
      }
    }
  }
</script>
